import { render, staticRenderFns } from "./bulkUploadAudio.vue?vue&type=template&id=5a158a42&"
import script from "./bulkUploadAudio.vue?vue&type=script&lang=js&"
export * from "./bulkUploadAudio.vue?vue&type=script&lang=js&"
import style0 from "./bulkUploadAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports